const COMBINING_MARKS = /[\u0300-\u036f]/g;

export function foldText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .toLowerCase();
}

export function searchTokens(query) {
  return foldText(query)
    .split(/[^a-z0-9]+/)
    .filter(Boolean);
}

function tokenScore(hay, token) {
  if (!hay || !token) return 0;
  if (hay === token) return 100;
  if (hay.startsWith(token)) return 80;
  const words = hay.split(/[^a-z0-9]+/);
  if (words.some((word) => word.startsWith(token))) return 55;
  if (hay.includes(token)) return 30;
  return 0;
}

function medicationHaystacks(med) {
  return {
    name: foldText(med?.name),
    extra: foldText(
      [med?.description, med?.category_name, med?.unit_name, med?.supplier].filter(Boolean).join(' ')
    )
  };
}

export function searchMedications(medications, query, { limit = 12 } = {}) {
  const list = Array.isArray(medications) ? medications : [];
  const toks = searchTokens(query);
  const byName = (a, b) =>
    String(a.name || '').localeCompare(String(b.name || ''), 'fr', { sensitivity: 'base' });

  if (!toks.length) {
    return [...list].sort(byName).slice(0, limit);
  }

  const ranked = [];
  list.forEach((med) => {
    const { name, extra } = medicationHaystacks(med);
    let score = 0;
    let miss = false;
    toks.forEach((tok) => {
      const best = Math.max(tokenScore(name, tok), extra ? tokenScore(extra, tok) * 0.45 : 0);
      if (best === 0) miss = true;
      else score += best;
    });
    if (miss) return;
    if (toks.every((tok) => name.includes(tok))) score += 20;
    ranked.push({ med, score });
  });

  ranked.sort((a, b) => b.score - a.score || byName(a.med, b.med));
  return ranked.slice(0, limit).map((row) => row.med);
}

export function highlightMatches(text, query) {
  const raw = String(text || '');
  const toks = searchTokens(query);
  if (!raw || !toks.length) return [{ mark: false, text: raw, key: 0 }];

  const folded = [];
  const orig = [];
  for (let i = 0; i < raw.length; i += 1) {
    const piece = foldText(raw[i]);
    for (let j = 0; j < piece.length; j += 1) {
      folded.push(piece[j]);
      orig.push(i);
    }
  }
  const hay = folded.join('');
  const marks = new Array(raw.length).fill(false);
  toks.forEach((tok) => {
    let from = 0;
    while (from <= hay.length - tok.length) {
      const i = hay.indexOf(tok, from);
      if (i < 0) break;
      const start = orig[i];
      const end = orig[i + tok.length - 1];
      for (let k = start; k <= end; k += 1) marks[k] = true;
      from = i + tok.length;
    }
  });

  const parts = [];
  let i = 0;
  while (i < raw.length) {
    const on = marks[i];
    let j = i + 1;
    while (j < raw.length && marks[j] === on) j += 1;
    parts.push({ mark: on, text: raw.slice(i, j), key: i });
    i = j;
  }
  return parts.length ? parts : [{ mark: false, text: raw, key: 0 }];
}
